import { Drawer } from 'flowbite';
import type { DrawerOptions, DrawerInterface } from 'flowbite';
import { createSidebarHTML } from '../templates/sidebar-template';
import { getConfig } from '../config';
import type { GdprAction } from '../types';

export default class gdprDrawer {

    private drawer: DrawerInterface | null = null;
    private abortController: AbortController | null = null;
    private isInserted: boolean = false;

    /**
     * Insert sidebar HTML into DOM (once) and bind action handlers
     */
    init(onAction: (action: GdprAction, parentId: string) => void): void {
        if (this.isInserted) return;

        const config = getConfig();
        if (!config) return;

        const html = createSidebarHTML(config);
        document.body.insertAdjacentHTML('beforeend', html);
        this.isInserted = true;

        this.drawer = this.createDrawer();
        this.bindActions(onAction);
    }

    show(): void {
        this.drawer?.show();
    }

    hide(): void {
        this.drawer?.hide();
    }

    destroy(): void {
        this.abortController?.abort();
        this.abortController = null;
        this.drawer?.hide();
        this.drawer = null;
        this.isInserted = false;
        document.getElementById('gdprSidebar')?.remove();
    }

    private createDrawer(): DrawerInterface | null {
        const el = document.getElementById('gdprSidebar');
        if (!el) return null;

        const options: DrawerOptions = {
            backdrop: false,
            bodyScrolling: false,
            backdropClasses: 'fixed inset-0 z-[5000] bg-gray-900/50',
            onHide: () => {
                el.classList.add('hidden');
            },
            onShow: () => {
                el.classList.remove('hidden');
            },
        };

        return new Drawer(el, options);
    }

    private bindActions(onAction: (action: GdprAction, parentId: string) => void): void {
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        // Action buttons (Accept All, Decline All, Save Preference)
        document.querySelectorAll<HTMLButtonElement>('.btn-dialog-gdpr[data-parent="gdprSidebar"]')
            .forEach((btn) => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    const action = btn.getAttribute('data-action') as GdprAction | null;
                    if (action) {
                        onAction(action, 'gdprSidebar');
                        this.hide();
                    }
                }, { signal });
            });
    }
}
